import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {MatInputModule} from "@angular/material/input";
import {FieldResource} from "../../core/modules/openapi";
import {Observable, of, switchMap} from "rxjs";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDialog} from "@angular/material/dialog";
import {ClientSearchComponent} from "../client-search/client-search.component";

@Component({
  selector: 'app-input-client-search',
  imports: [MatFormFieldModule, MatCheckboxModule, ReactiveFormsModule, CommonModule, MatInputModule, FormsModule, MatIconModule, MatButtonModule, MatTooltipModule],
  templateUrl: './input-client-search.component.html',
  standalone: true,
  styleUrl: './input-client-search.component.sass'
})
export class InputClientSearchComponent implements OnInit, AfterViewInit {
  @Input() field: FieldResource;
  group: FormGroup;
  defaultValue: string;
  subject: Observable<string>;
  visible: Observable<boolean>;

  constructor(public dialog: MatDialog) {
  }

  ngAfterViewInit(): void {
    this.defaultValue = this.field?.value?.toString() || '';
  }

  ngOnInit() {
    this.visible = this.subject.pipe(switchMap(x => of(this.isVisible(x))));
  }

  changeStatus(event: { checked: any; }) {
    if (event.checked) {
      this.group.controls[this.field.name]?.enable();
      this.field.enabled = true;
      this.group.controls[this.field.name]?.setValue(this.defaultValue);
      this.field.value = this.defaultValue;
    } else {
      this.group.controls[this.field.name]?.disable();
      this.field.enabled = false;
      this.group.controls[this.field.name]?.setValue("");
      this.field.value = "";
    }
  }

  isVisible(value: string) {
    if (this.field.visibilityGroup && this.field.visibilityGroup === value) {
      this.group.controls[this.field.name]?.enable();
      return true;
    } else if (!this.field.visibilityGroup) {
      this.group.controls[this.field.name]?.enable();
      return true;
    } else {
      this.group.controls[this.field.name]?.disable();
      return false;
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(ClientSearchComponent, {
      width: "900px",
      height: "463px",
      maxWidth: "900px",
      maxHeight: "500px"
    });
    const subscribeDialog = dialogRef.componentInstance.selectedUser.subscribe((data) => {
      //this.selectUser(data);
    });
  }
}
